import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { Link } from "react-router-dom";
import { handleKeyDown } from "../../blueplanitUtils/DatePickerAutoformate";
import { handleDeleteItem } from "./HandleDeleteFunction";
import { setFamilyMemberses } from "../../Slices/employeeslice";
import { InputField, DatePickerField, SelectInput } from "../../blueplanitUtils/InputField";
import Modal from "../../blueplanitUtils/Modal";
import { handleClose } from "./HandleClosePop/handleclose";
import { getOptionsByPath } from "../../utilsdata";
import { FAMILY_INFO,DEPENDENT } from "../../Dropdownmanager";
export const FamilyModelPopup = () => {
  const dispatch = useDispatch();
  const Familyup = useSelector((state) => state.employee.familyMembers);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  const { handleSubmit } = useFormHandler();
  const [familyErrors, setFamilyErrors] = useState({});
  const [isFamilyFormValid, setIsFamilyFormValid] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  useEffect(() => {
    setFamilyMembers(Familyup)
  }, [Familyup])

  const validateFamilyMembers = (familyMembers) => {
    const errors = {};
    const alphaRegex = /^[A-Za-z\s-]+$/;
    const currentDate = new Date();

    familyMembers.forEach((family, index) => {
      const memberErrors = {};
      let calculatedAge = family.age; 

      if (!family.name?.trim()) {
        memberErrors.name = "Name is required";
      } else if (!alphaRegex.test(family.name)) {
        memberErrors.name = "Name must contain only letters";
      }

      if (!family.relationship?.trim()) {
        memberErrors.relationship = "Relationship is required";
      } else if (!alphaRegex.test(family.relationship)) {
        memberErrors.relationship = "Relationship must contain only letters";
      }

      if (!family.dob) {
        memberErrors.dob = "Date of Birth is required";
      } else {
        const dobDate = new Date(family.dob);
        if (dobDate > currentDate) {
          memberErrors.dob = "Date of Birth cannot be in the future";
        } else {
          const ageDiff = currentDate.getFullYear() - dobDate.getFullYear();
          const monthDiff = currentDate.getMonth() - dobDate.getMonth();
          const dayDiff = currentDate.getDate() - dobDate.getDate();
          calculatedAge = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? ageDiff - 1 : ageDiff;

          if (calculatedAge < 0 || calculatedAge > 99) {
            memberErrors.age = "Age should be between 0 and 99";
          }
        }
      }

      if (family.age && (family.age < 0 || family.age > 99)) {
        memberErrors.age = "Age should be between 0 and 99";
      }

      if (!family.dependent?.trim()) {
        memberErrors.dependent = "Dependent status is required";
      } else if (!["Yes", "No"].includes(family.dependent)) {
        memberErrors.dependent = "Dependent must be Yes or No";
      }

      if (Object.keys(memberErrors).length > 0) {
        errors[index] = memberErrors;
      }
    });

    return errors;
  };


  const handleFamilyChange = (index, e) => {
    let name, value;

    if (e && e.target) {
      name = e.target.name;
      value = e.target.value;
    } else if (e instanceof Date) {
      name = e.name;
      value = e;
    } else {
      return;
    }

    const updatedFamilyData = [...familyMembers];
    if (!updatedFamilyData[index]) updatedFamilyData[index] = {};

    updatedFamilyData[index] = { ...updatedFamilyData[index], [name]: value };

    if (name === "dob" && value) {
      const dobDate = new Date(value);
      const currentDate = new Date();
      let age = currentDate.getFullYear() - dobDate.getFullYear();
      const monthDiff = currentDate.getMonth() - dobDate.getMonth();
      const dayDiff = currentDate.getDate() - dobDate.getDate();

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--; 
      }

      if (age >= 0 && age <= 99) {
        updatedFamilyData[index].age = age.toString();
      }
    }

    const updatedErrors = validateFamilyMembers(updatedFamilyData);

    Object.keys(updatedErrors).forEach((key) => {
      if (Object.keys(updatedErrors[key]).length === 0) {
        delete updatedErrors[key];
      }
    });

    setFamilyMembers(updatedFamilyData);
    setFamilyErrors(updatedErrors);
    setIsFamilyFormValid(Object.keys(updatedErrors).length === 0);
  };



  const addFamilyMember = () => {
    const newFamily = {
      name: "",
      relationship: "",
      dob: "",
      age: "",
      dependent: "",
    };

    setFamilyMembers((prev) => [...prev, newFamily]);
    setIsFamilyFormValid(false);
  };

  const removeFamilyMember = (index) => {
    handleDeleteItem(index, familyMembers, setFamilyMembers, familyErrors, setFamilyErrors, setIsFamilyFormValid);
  };

  const FamilyhandleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = validateFamilyMembers(familyMembers);

    setFamilyErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;
    const formattedFamilyData = familyMembers?.map(({ __typename, ...family }) => family);
    const input = { familyMembers: formattedFamilyData }
    try {
      const val = await handleSubmit({
        noErrors,
        formValid: isFamilyFormValid,
        dataObj: input,
        action: "familyDetaild",
        ModalName: "familyModelpopUp",
        submitAction: "handleFamilySubmit",
      });

      if (val) {
        dispatch(setFamilyMemberses(formattedFamilyData));
        setIsFamilyFormValid(false)
      }
    } catch (error) {

    } finally {
      setIsFamilyFormValid(false);
    }

  };
  return (
    <Modal id="family_info_modal"
      title="Family Information"
      handleModalClose={() => handleClose(Familyup,
        setFamilyMembers,
        setFamilyErrors,
        setIsFamilyFormValid
      )}
      handleSubmit={FamilyhandleSubmit}
      isUserDataValid={false}>
      <div className="form-scroll">
        {familyMembers?.map((member, index) => (
          <div className="card mb-4" key={index}>
            <div className="card-body">
              <h3 className="card-title">
                Family Information {index + 1}
                <Link
                  to="#"
                  className="delete-icon"
                  onClick={() => removeFamilyMember(index)}
                >
                  <i className="fa-regular fa-trash-can" />
                </Link>
              </h3>
              <div className="row">

                {/* Name Field */}
                <div className="col-md-6">
                  <div className="form-group mb-2">
                    <InputField
                      formcontrol="form-control"
                      label="Name"
                      type="text"
                      name="name"
                      value={member?.name}
                      onChange={(e) => handleFamilyChange(index, e)}
                      placeholder="Enter Name"
                      error={familyErrors[index]?.name}
                    />

                  </div>
                </div>
                {/* Relationship Field */}
                <div className="col-md-6">
                  <div className="form-group mb-2">
                    <InputField
                      formcontrol="form-control"
                      label="Relationship"
                      type="text"
                      name="relationship"
                      value={member?.relationship}
                      onChange={(e) => handleFamilyChange(index, e)}
                      placeholder="Enter Relationship"
                      error={familyErrors[index]?.relationship}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {/* Date of Birth Field */}
                <div className="col-md-6">
                  <div className="form-group mb-2">
                    <DatePickerField
                      formcontrol="form-control"
                      label="DOB"
                      format="DD/MM/YYYY"
                      name="dob"
                      value={member?.dob ? dayjs(member?.dob) : null}
                      onChange={(date) => {
                        const isoString = date ? date.toISOString() : null;
                        handleFamilyChange(index, { target: { name: "dob", value: isoString } });
                      }}
                      onKeyDown={handleKeyDown}
                      error={familyErrors[index]?.dob}
                      style={{ width: "100%" }}
                      getPopupContainer={(trigger) => trigger.parentElement} // Prevents form from moving
                      onFocus={(e) => e.preventDefault()} // Stops auto-scroll on focus
                      autoFocus={false}
                    />

                  </div>
                </div>
                {/* Age Field */}
                <div className="col-md-6">
                  <div className="form-group mb-3">
                    <InputField
                      formcontrol="form-control"
                      label="Age"
                      type="text"
                      name="age"
                      value={member?.age}
                      onChange={(e) => handleFamilyChange(index, e)}
                      placeholder="Enter Age"
                      error={familyErrors[index]?.age}
                      disabled={true}
                    />

                  </div>
                </div>

                {/* Dependent Field */}
                <div className="col-md-6">
                  <SelectInput
                    label="Dependent"
                    formControl={true}
                    required={true}
                    style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                    error={familyErrors[index]?.dependent}
                    placeholder="Select Dependent Status"
                    options={getOptionsByPath(NestedDatabucket, [FAMILY_INFO, DEPENDENT])}
                    className="form-control"
                    name="dependent"
                    value={member?.dependent}
                    onChange={(value) => handleFamilyChange(index, { target: { name: "dependent", value } })}
                  />
                </div>

              </div>

            </div>
          </div>
        ))}

        {/* Add More Button */}
        <div className="add-more mb-2">
          <Link to="#" onClick={addFamilyMember}>
            <i className="fa-solid fa-plus-circle" /> Add More
          </Link>
        </div>
        {/* Submit Button */}
      </div>
    </Modal>

  )
}